import { Component, type ReactNode, type ErrorInfo } from "react";
import { Alert, Button } from "@vlab-corporation/design-system";
import { trackError } from "@/utils/error-tracking";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    trackError(error, {
      source: "ErrorBoundary",
      componentStack: errorInfo.componentStack?.slice(0, 500) ?? "",
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4">
          <Alert variant="error" className="mb-4 max-w-md">
            문제가 발생했습니다. 다시 시도해주세요.
          </Alert>
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => this.setState({ hasError: false })}>
              다시 시도
            </Button>
            <Button variant="primary" onClick={() => window.location.reload()}>
              페이지 새로고침
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
